import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

// Images
import CrossIcon from 'images/icons/cross.svg';

import './style.css';

ReactModal.setAppElement('#root');

class Modal extends React.Component {
  render() {
    const { title, showCloseButton, children, onRequestClose } = this.props;

    return (
      <ReactModal
        aria={{
          labelledby: 'modal-title'
        }}
        {...this.props}
        ref={(node) => { this.modal = node; }}
      >
        { showCloseButton && (
          <button type="button" className="close-button" onClick={onRequestClose}>
            <img src={CrossIcon} alt="Close modal" />
          </button>
        )}
        <h1 id="modal-title">{title}</h1>
        {children}
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  // Title of the modal
  title: PropTypes.string.isRequired,
  // Whether the modal displays a close button
  showCloseButton: PropTypes.bool,
  // Function executed when the user wants to close the modal
  onRequestClose: PropTypes.func,
  // Content of the modal
  children: PropTypes.node.isRequired
};

Modal.defaultProps = {
  showCloseButton: true,
  onRequestClose: () => {}
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/component.js